import React from 'react';
import { useLoginViewModel } from '../view-models/useLoginViewModel';

import { Button } from '@/shared';
import GradientBackground from '@/shared/infra/ui/components/GradientBackground';
import { FieldLabel } from '@/shared/infra/ui/components/ui/field';
import { LOGIN_LABELS } from './LoginPage.labels';

const LoginPage: React.FC = () => {
  const {
    startI9Flow,
    handleEmployerLogin,
    // handleEmployerLoginMock
  } = useLoginViewModel();

  return (
    <GradientBackground>
      <div className="flex flex-col items-center justify-center min-h-screen relative m-0 p-4 md:p-0 border-0">
        {/* Logo */}
        <div className="w-full flex justify-center items-center mb-4 md:mb-8 z-10">
          <div className="h-14 md:h-18 w-32 md:w-48 rounded-lg flex items-center justify-center text-white font-bold text-xl">
            <img src="/svg/VT-logo.svg" alt="Logo" className="h-18 object-contain" />
          </div>
        </div>

        {/* Bottom right transparent logo - hidden on mobile */}
        <img
          className="absolute right-[-15%] bottom-[-20%] md:right-[-5%] md:bottom-[-25%] w-[400px] h-[400px] md:w-[600px] md:h-[600px] rounded-full z-[1]"
          src="/svg/verify_login_bg.svg"
          alt="Decorative"
        />

        {/* Main Card */}
        <div
          className="
            bg-white flex flex-col shadow-lg overflow-hidden border-0 z-[2] mt-4 md:mt-8 rounded-lg md:rounded-none
            w-[90%] max-w-[90%]
            sm:max-w-[85%]
            md:min-w-[60%] md:w-[70%]
            lg:max-w-[70%] lg:w-[70%]
          "
        >
          {/* Login Header */}
          <div className="w-full flex justify-center items-center py-3 md:py-2 mt-2 md:mt-4">
            <FieldLabel className="text-center text-xl md:text-2xl font-bold m-0 text-dark-gray tracking-wide">
              {LOGIN_LABELS.login}
            </FieldLabel>
          </div>

          <div className="flex flex-col md:flex-row w-full flex-1 h-full">
            {/* Left Section for Employee */}
            <div className="flex-1 flex flex-col items-center justify-start p-6 md:p-10">
              <FieldLabel className="mb-4 md:mb-6 text-lg md:text-2xl whitespace-pre-line font-regular text-dark-gray text-center">
                {LOGIN_LABELS.newEmployees}
              </FieldLabel>
              <Button
                className="h-auto w-full sm:w-fit whitespace-normal py-2 my-4 md:my-8 px-6 text-white border-none rounded-md cursor-pointer font-bold tracking-wide text-sm sm:text-base md:text-xs transition-all"
                variant={'verify_i9'}
                onClick={startI9Flow}
              >
                <span className="break-words whitespace-normal">{LOGIN_LABELS.beginI9}</span>
              </Button>
            </div>

            {/* Divider - Horizontal on mobile, Vertical on desktop */}
            <div className="flex md:flex-col items-center justify-center w-full md:w-16 py-4 md:py-10 px-10 md:px-0">
              <div className="h-px md:h-30 w-30 md:w-px bg-dark-gray" />
              <span className="mx-4 md:mx-0 md:my-2 font-medium text-dark-gray text-sm whitespace-nowrap text-center">
                {LOGIN_LABELS.divider}
              </span>
              <div className="h-px md:h-30 w-30 md:w-px bg-dark-gray" />
            </div>

            {/* Right Section for Employer */}
            <div className="flex-1 flex flex-col justify-start items-center p-6 md:p-10">
              <FieldLabel className="mb-4 md:mb-6 text-lg md:text-2xl whitespace-pre-line font-regular text-dark-gray text-center align-middle">
                {LOGIN_LABELS.employerLogin}
              </FieldLabel>
              <Button
                type="button"
                variant={'pending'}
                onClick={handleEmployerLogin}
                className="h-auto w-full sm:w-fit whitespace-normal py-2 my-4 md:my-8 px-20 text-white border-none rounded-md cursor-pointer font-bold tracking-wide text-sm sm:text-base md:text-xs transition-all"
              >
                {LOGIN_LABELS.btnLogin}
              </Button>
              {/* <Button
                type="button"
                variant={'pending'}
                onClick={handleEmployerLoginMock}
                className="h-auto w-full sm:w-fit whitespace-normal py-2 my-4 md:my-8 px-20 text-white border-none rounded-md cursor-pointer font-bold tracking-wide text-sm sm:text-base md:text-xs transition-all"
              >
                Mock Login
              </Button> */}
            </div>
          </div>
        </div>
      </div>
    </GradientBackground>
  );
};

export default LoginPage;
